$(document).ready(function () {


    if ($(window).width() <= 992) {
        $(".footer-block--menu").click(function () {
            $(this).find("ul").slideToggle();
            $(this).find("h2").toggleClass("minus");
        });
    }

});

  window.onscroll = function(){ scrollFunction() };

  
  function scrollFunction() {

    // SITE SCROLLER
    if($(window).scrollTop()>200){
      $("#site-scroll").fadeIn();
    } else {
      $("#site-scroll").fadeOut();
    }
  }

    $("#site-scroll").click(function() {
      $("html, body").animate({ scrollTop: 0 }, 1000);
      return false;
    }); 